export default "__VITE_ASSET__DPs$JGxC__"